import { Alert } from '../../../../../dist/lib-components/public_api';

export class QueovalBase {
  CodedAlerts: Array<Alert>;
  Error: string;
  Alert: string;
  HasError: boolean;
  Mode: string;
  Action: string;
}
